import { testDevice, SMALL_DEVICE_FONT_WEIGHT } from './device.css';

const isBrowser = typeof window !== 'undefined';

let testDiv: HTMLElement;
const createTestElement = () => {
  if (document && !testDiv) {
    testDiv = document.createElement('div');
    testDiv.className = testDevice;
    document.body.appendChild(testDiv);
  }
  return testDiv;
};

export const isSmallDevice = (): boolean => {
  let result = false;
  if (isBrowser) {
    const ele = createTestElement();
    if (ele) {
      const fontWeight: string = window.getComputedStyle(ele).fontWeight || '';
      result = fontWeight === String(SMALL_DEVICE_FONT_WEIGHT);
    }
  }
  return result;
};
